import { Input } from '@chakra-ui/react'
import { Controller } from 'react-hook-form'
import InputMask from 'react-input-mask'

const InputIDCard = ({ control, required = true, ...rest }) => {
    return (
        <Controller
            name="id_card"
            control={control}
            rules={{
                required: required,
                minLength: 13
            }}
            render={({ field }) =>
                <Input
                    as={InputMask}
                    mask="9 9999 99999 99 9"
                    type="text"
                    placeholder="กรอกหมายเลขบัตรประจำตัวประชาชน 13 หลัก"
                    {...rest}
                    {...field}
                />
            }
        />

    )
}

export default InputIDCard
